import { render, staticRenderFns } from "./importRoomFee.vue?vue&type=template&id=e4755066&scoped=true"
import script from "./importRoomFee.vue?vue&type=script&lang=js"
export * from "./importRoomFee.vue?vue&type=script&lang=js"
import style0 from "./importRoomFee.vue?vue&type=style&index=0&id=e4755066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4755066",
  null
  
)

export default component.exports